import { useEffect, useState } from "react";
import DashboardShell from "@/components/DashboardShell";
import { api, fmtBps, formatErr } from "@/lib/api";
import { toast } from "sonner";

export default function AdminFeeConfig() {
  const [cfg, setCfg] = useState(null);
  const [form, setForm] = useState({});

  useEffect(() => { api.get("/admin/fee-config").then((r) => { setCfg(r.data); setForm(r.data); }); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        platform_txn_fee_bps: Number(form.platform_txn_fee_bps),
        platform_late_fee_bps: Number(form.platform_late_fee_bps),
        dsa_commission_bps: Number(form.dsa_commission_bps),
        wallet_float_spread_bps: Number(form.wallet_float_spread_bps),
        default_loan_interest_bps: Number(form.default_loan_interest_bps),
      };
      const { data } = await api.put("/admin/fee-config", payload);
      setCfg(data); toast.success("Configuration saved");
    } catch (e) { toast.error(formatErr(e?.response?.data?.detail) || e.message); }
  };

  if (!cfg) return <DashboardShell title="Fee config"><p>Loading…</p></DashboardShell>;

  const fields = [
    { k: "platform_txn_fee_bps", label: "Transaction fee", help: "Charged on every collection. 100 bps = 1%." },
    { k: "platform_late_fee_bps", label: "Late payment fee", help: "Per overdue installment." },
    { k: "dsa_commission_bps", label: "DSA commission", help: "Of platform revenue. 125 bps = 1.25%." },
    { k: "wallet_float_spread_bps", label: "Wallet float spread", help: "Net APR earned on parent wallets." },
    { k: "default_loan_interest_bps", label: "Default loan APR", help: "Per year. AI may suggest higher per applicant." },
  ];

  return (
    <DashboardShell title="Commercial configuration" subtitle="Edit basis points — every change is published platform-wide.">
      <form onSubmit={save} className="card max-w-3xl" data-testid="fee-config-form">
        <div className="grid sm:grid-cols-2 gap-5">
          {fields.map((f) => (
            <label key={f.k} className="block">
              <div className="flex items-baseline justify-between">
                <span className="text-xs uppercase tracking-[0.14em] text-[#4F5D4F] font-semibold">{f.label}</span>
                <span className="text-xs text-[#F2B632] font-mono">{fmtBps(form[f.k] || 0)}</span>
              </div>
              <input type="number" min="0" max="10000" className="input mt-1" value={form[f.k] || 0} onChange={(e) => setForm({ ...form, [f.k]: e.target.value })} data-testid={`config-${f.k}`} />
              <p className="text-xs text-[#4F5D4F] mt-1">{f.help}</p>
            </label>
          ))}
        </div>
        <button type="submit" className="btn-primary mt-7" data-testid="save-fee-config">Save configuration</button>
      </form>
    </DashboardShell>
  );
}
